import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="15" y="30" rx="4" ry="4" width="30" height="30" />
      <rect x="62" y="36" rx="3" ry="3" width="80" height="6" />
      <rect x="62" y="48" rx="3" ry="3" width="338" height="6" />
    </React.Fragment>
  );
};
